<template>
  <div class="menu is-right" :class="{ 'is-open': isOpen }">
    <div class="menu-overlay" @click.self="close">
      <div class="menu-content-wrapper">
        <div class="menu-content" ref="scrollArea">
          <header class="menu-header">
            <div class="menu-header-title">
              <p class="text-break">アンケートのロック</p>
            </div>
          </header>
          <ul class="menu-link-list">
            <li class="menu-link-item">
              <label for="question-lock-all" class="checkbox">
                <input
                  id="question-lock-all"
                  type="checkbox"
                  v-model="all"
                  @change="onAllToggle"
                />
                <span class="checkbox-text">全て選択</span>
              </label>
            </li>
          </ul>
          <ul class="menu-link-list">
            <li
              v-for="dialog in dialogs"
              :key="dialog.id"
              class="menu-link-item"
            >
              <label :for="`dialog-${dialog.id}`" class="checkbox">
                <input
                  :id="`dialog-${dialog.id}`"
                  type="checkbox"
                  :value="dialog.id"
                  v-model="checks"
                  @change="onToggle"
                />
                <span class="checkbox-text" v-html="dialog.title"></span>
              </label>
            </li>
          </ul>
          <footer class="menu-footer">
            <div class="text-center">
              <WaveButton @click="save" :loading="loading">
                適用する
              </WaveButton>
            </div>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/question'
import Dialog from '@/utils/Dialog'
import { renderError } from '@/utils/error'

export default {
  data() {
    return {
      checks: [],
      all: false,
      loading: false
    }
  },

  computed: {
    isOpen() {
      return this.$store.state.navbar.isQuestionLockOpen
    },
    businessId() {
      return this.$store.getters['auth/businessId']
    },
    dialogs() {
      return this.$store.state.dialog.items
    },
    postData() {
      return this.dialogs.map(qa => ({
        dialog_id: qa.id,
        locked: this.checks.includes(qa.id),
        revision: qa.revision
      }))
    }
  },

  methods: {
    onAllToggle() {
      this.checks = this.all
        ? this.dialogs.map(c => c.id)
        : []
    },
    onToggle() {
      this.all = this.checks.length === this.dialogs.length
    },
    async save() {
      this.loading = true

      try {
        const response = await api.lock(this.businessId, this.postData)

        // アンケート一覧を更新
        const newDialogs = this.getNewDialogs(response.revision_list)
        this.$store.commit('dialog/SET_ITEMS', newDialogs)

        this.$modal.show('dialog-lock-modal')
      } catch(err) {
        renderError(err)
      } finally {
        this.close()
        this.loading = false
      }
    },
    getNewDialogs(revisionList) {
      return this.dialogs.map(res => {
        const revisionItem = revisionList.find(
          r => r.unique_key * 1 === res.id * 1
        )
        const revision = revisionItem ? revisionItem.revision : res.revision
        const locked = this.checks.includes(res.id)
        return new Dialog({
          id: res.id,
          title: res.title,
          questionCount: res.questionCount,
          answerCount: res.answerCount,
          locked: locked,
          revision: revision
        })
      })
    },
    close() {
      this.$store.commit('navbar/toggleQuestionLock')
    }
  },

  watch: {
    dialogs: {
      handler(val) {
        this.checks = val.filter(v => v.locked).map(v => v.id)
      },
      immediate: true
    },
    watch: {
      isOpen(val) {
        if (val) {
          this.$nextTick(() => {
            this.$refs.scrollArea.scrollTop = 0
          })
        }
      }
    }
  }
}
</script>
